// LandingView.js — ACES Cities Network
// Tipografía: Axiforma Bold (títulos) + Roboto (textos)
// Iconos: SVG inline
// Datos: verificados en aceseurope.eu
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const T = {
  es: {
    nav_roles:'Roles', nav_proceso:'Proceso', nav_galardones:'Galardones',
    nav_funciones:'Funciones', nav_acceder:'Acceder', nav_registro:'Registrarse',
    badge:'Plataforma oficial ACES Europa & Américas',
    hero_h1a:'La gestión digital de las',
    hero_h1b:'candidaturas ACES',
    hero_sub:'ACES Cities Network gestiona el ciclo completo de candidaturas a los premios deportivos ACES — desde la carta de intención del Alcalde hasta la ceremonia en el Parlamento Europeo, completamente digital.',
    hero_cta1:'Crear cuenta', hero_cta2:'Iniciar sesión',
    ios_label:'Disponible en', ios_store:'App Store',
    android_label:'Únete a la', android_store:'Beta Android',
    s1_num:'5.000+', s1_lbl:'municipios en la red ACES',
    s2_num:'20+', s2_lbl:'galardones deportivos oficiales',
    s3_num:'7', s3_lbl:'idiomas',
    s4_num:'1999', s4_lbl:'año de fundación ACES',
    roles_lbl:'Para quién', roles_h:'Tres roles, una plataforma',
    roles_p:'Cada parte tiene una interfaz dedicada y adaptada a su rol en el proceso de candidatura.',
    rm_tag:'MASTER · ADMIN', rm_h:'Administración ACES',
    rm_p:'Control total sobre todas las candidaturas, evaluadores y el proceso de adjudicación.',
    rm_f:['Panel global de candidaturas','Asignar comisiones evaluadoras','Decisión final de adjudicación','Gestión de gala y titularidades','Generación de códigos de acceso'],
    re_tag:'EVALUADOR', re_h:'Evaluadores técnicos',
    re_p:'Expertos independientes que evalúan candidaturas según los criterios oficiales ACES.',
    re_f:['Motor de evaluación 12 secciones','Sistema de puntuación hasta 100 pts','Chat interno de comisión','Logística de viaje asignada','Declaración de conflicto de interés'],
    rc_tag:'CIUDAD', rc_h:'Ciudades candidatas',
    rc_p:'Municipios que aspiran al reconocimiento ACES. Sigue tu candidatura en tiempo real.',
    rc_f:['Estado del proceso en tiempo real','Portal de documentos y BID file','Seguimiento de pagos','Logística de la visita evaluadora','Chat directo con ACES'],
    pipe_lbl:'El proceso de candidatura', pipe_h:'8 fases, gestionadas digitalmente',
    pipe_p:'Carta de intención del Alcalde · Firma del reglamento · Fee de candidatura · BID File · Visita del comité evaluador · Ceremonia en el Parlamento Europeo (Bruselas)',
    stages:['Solicitada','Aceptada','Documentación','Visita','Evaluación','Votación','Decisión','Adjudicada'],
    aw_lbl:'Galardones', aw_h:'Los reconocimientos oficiales ACES gestionados en una plataforma',
    aw_p:'Desde la Capital Mundial del Deporte hasta Ciudades, Regiones, Islas y Comunidades de Europa, América, África, Asia y Oceanía.',
    ft_lbl:'Funciones', ft_h:'Todo lo que necesitas para gestionar una candidatura ACES',
    feats:[
      {h:'7 idiomas',p:'Español, inglés, francés, alemán, italiano, neerlandés y portugués.'},
      {h:'Seguridad por roles',p:'Las ciudades nunca ven puntuaciones. La identidad de los evaluadores es confidencial.'},
      {h:'Motor de evaluación oficial',p:'Basado en criterios ACES oficiales. 12 secciones, hasta 100 puntos.'},
      {h:'Chat en dos canales',p:'Canal ciudad-ACES y canal interno de comisión en tiempo real.'},
      {h:'Logística de viajes',p:'Las ciudades proponen vuelos y hoteles. Los evaluadores confirman.'},
      {h:'iOS, Android y Web',p:'Apps nativas y panel web sincronizados en tiempo real vía Firebase.'},
      {h:'Gestión documental',p:'Sube, revisa y aprueba BID files. Historial completo de versiones.'},
      {h:'Seguimiento de titularidades',p:'Controla obligaciones: imagen corporativa, calendario deportivo, memorias anuales.'},
    ],
    cta_h:'¿Listo para presentar tu candidatura?',
    cta_p:'Accede con tu código ACES o inicia sesión como miembro existente.',
    cta_b1:'Crear cuenta', cta_b2:'Contactar ACES',
    footer_legal:'© 2026 ACES América. Todos los derechos reservados.',
    footer_privacy:'Política de privacidad', footer_contact:'Contacto',
    cookie_msg:'Usamos cookies esenciales para el funcionamiento de la plataforma. Sin cookies de seguimiento ni datos compartidos.',
    cookie_accept:'Aceptar', cookie_reject:'Solo esenciales', cookie_more:'Saber más',
  },
  en: {
    nav_roles:'Roles', nav_proceso:'Process', nav_galardones:'Awards',
    nav_funciones:'Features', nav_acceder:'Sign In', nav_registro:'Register',
    badge:'Official ACES Europe & Americas Platform',
    hero_h1a:'The digital management of',
    hero_h1b:'ACES candidatures',
    hero_sub:'ACES Cities Network manages the complete lifecycle of ACES sport award candidatures — from the Mayor\'s letter of intention to the ceremony at the European Parliament, fully digital.',
    hero_cta1:'Create account', hero_cta2:'Sign in',
    ios_label:'Available on the', ios_store:'App Store',
    android_label:'Join the', android_store:'Android Beta',
    s1_num:'5,000+', s1_lbl:'municipalities in the ACES network',
    s2_num:'20+', s2_lbl:'official sport awards',
    s3_num:'7', s3_lbl:'languages',
    s4_num:'1999', s4_lbl:'ACES founded',
    roles_lbl:'Who is it for', roles_h:'Three roles, one platform',
    roles_p:'Each stakeholder has a dedicated interface tailored to their role in the candidature process.',
    rm_tag:'MASTER · ADMIN', rm_h:'ACES Administration',
    rm_p:'Full control over all candidatures, evaluators, and the adjudication process.',
    rm_f:['Global candidature dashboard','Assign evaluation committees','Final adjudication decision','Gala & titularity management','Access code generation'],
    re_tag:'EVALUATOR', re_h:'Technical Evaluators',
    re_p:'Independent experts assessing candidatures according to official ACES criteria.',
    re_f:['12-section evaluation engine','Scoring system up to 100 pts','Internal committee chat','Assigned travel logistics','Conflict of interest declaration'],
    rc_tag:'CITY', rc_h:'Candidate Cities',
    rc_p:'Municipalities applying for ACES recognition. Track your candidature in real time.',
    rc_f:['Real-time process status','Document & BID file portal','Payment tracking','Evaluator visit logistics','Direct chat with ACES'],
    pipe_lbl:'The candidature journey', pipe_h:'8 stages, fully managed',
    pipe_p:'Letter of intention from the Mayor · Sign Regulations · Candidature fee · Bid File · Evaluation Committee visit · Award Ceremony at the European Parliament (Brussels)',
    stages:['Applied','Accepted','Documentation','Visit','Evaluation','Voting','Decision','Awarded'],
    aw_lbl:'Awards', aw_h:'All official ACES sport awards managed on one platform',
    aw_p:'From the World Capital of Sport to Cities, Regions, Islands and Communities across Europe, the Americas, Africa, Asia and Oceania.',
    ft_lbl:'Features', ft_h:'Everything you need to manage an ACES candidature',
    feats:[
      {h:'7 Languages',p:'Spanish, English, French, German, Italian, Dutch and Portuguese.'},
      {h:'Role-based security',p:'Cities never see scores. Evaluator identities are confidential.'},
      {h:'Official evaluation engine',p:'Based on official ACES criteria. 12 sections, up to 100 points.'},
      {h:'Dual-channel chat',p:'City-ACES and internal committee channels. Real-time messaging.'},
      {h:'Travel logistics',p:'Cities propose flights and hotels. Evaluators confirm. Fully traceable.'},
      {h:'iOS, Android & Web',p:'Native apps and web panel synced in real time via Firebase.'},
      {h:'Document management',p:'Upload, review, and approve BID files. Full version history.'},
      {h:'Titularity tracking',p:'Track obligations: corporate image, sport calendar, annual reports.'},
    ],
    cta_h:'Ready to start your candidature?',
    cta_p:'Access with your ACES code or sign in as an existing member.',
    cta_b1:'Create account', cta_b2:'Contact ACES',
    footer_legal:'© 2026 ACES América. All rights reserved.',
    footer_privacy:'Privacy Policy', footer_contact:'Contact',
    cookie_msg:'We use essential cookies for the platform to function. No tracking cookies or third-party data sharing.',
    cookie_accept:'Accept', cookie_reject:'Essential only', cookie_more:'Learn more',
  },
  fr: {
    nav_roles:'Rôles', nav_proceso:'Processus', nav_galardones:'Prix',
    nav_funciones:'Fonctions', nav_acceder:'Connexion', nav_registro:'S\'inscrire',
    badge:'Plateforme officielle ACES Europe & Amériques',
    hero_h1a:'La gestion numérique des',
    hero_h1b:'candidatures ACES',
    hero_sub:'ACES Cities Network gère le cycle complet des candidatures aux prix sportifs ACES — de la lettre d\'intention du Maire à la cérémonie au Parlement Européen, entièrement numérique.',
    hero_cta1:'Créer un compte', hero_cta2:'Se connecter',
    ios_label:'Disponible sur', ios_store:'App Store',
    android_label:'Rejoindre la', android_store:'Beta Android',
    s1_num:'5 000+', s1_lbl:'municipalités dans le réseau ACES',
    s2_num:'20+', s2_lbl:'prix sportifs officiels',
    s3_num:'7', s3_lbl:'langues',
    s4_num:'1999', s4_lbl:'fondation ACES',
    roles_lbl:'Pour qui', roles_h:'Trois rôles, une plateforme',
    roles_p:'Chaque partie dispose d\'une interface dédiée adaptée à son rôle dans le processus.',
    rm_tag:'MASTER · ADMIN', rm_h:'Administration ACES',
    rm_p:'Contrôle total sur toutes les candidatures, évaluateurs et le processus d\'adjudication.',
    rm_f:['Tableau de bord global','Assigner des comités','Décision finale','Gala et titularité','Génération de codes'],
    re_tag:'ÉVALUATEUR', re_h:'Évaluateurs techniques',
    re_p:'Experts indépendants évaluant les candidatures selon les critères officiels ACES.',
    re_f:['Moteur 12 sections','Notation jusqu\'à 100 pts','Chat interne','Logistique de voyage','Conflit d\'intérêt'],
    rc_tag:'VILLE', rc_h:'Villes candidates',
    rc_p:'Municipalités aspirant à la reconnaissance ACES. Suivez votre candidature en temps réel.',
    rc_f:['Statut en temps réel','Portail documents','Paiements','Logistique visite','Chat avec ACES'],
    pipe_lbl:'Le parcours', pipe_h:'8 étapes, entièrement gérées',
    pipe_p:'Lettre du Maire · Règlement · Frais · BID File · Visite du comité · Cérémonie au Parlement Européen (Bruxelles)',
    stages:['Soumise','Acceptée','Documentation','Visite','Évaluation','Vote','Décision','Adjugée'],
    aw_lbl:'Prix', aw_h:'Tous les prix sportifs officiels ACES sur une seule plateforme',
    aw_p:'De la Capitale Mondiale du Sport aux Villes, Régions, Îles et Communautés en Europe, Amériques, Afrique, Asie et Océanie.',
    ft_lbl:'Fonctions', ft_h:'Tout pour gérer une candidature ACES',
    feats:[
      {h:'7 Langues',p:'Espagnol, anglais, français, allemand, italien, néerlandais et portugais.'},
      {h:'Sécurité par rôles',p:'Les villes ne voient jamais les scores. Identité des évaluateurs confidentielle.'},
      {h:'Moteur officiel',p:'12 sections, jusqu\'à 100 points.'},
      {h:'Chat double canal',p:'Canal ville-ACES et canal interne en temps réel.'},
      {h:'Logistique',p:'Les villes proposent vols et hôtels. Les évaluateurs confirment.'},
      {h:'iOS, Android et Web',p:'Applications natives et panneau web synchronisés.'},
      {h:'Gestion documentaire',p:'Téléchargez, révisez et approuvez les BID files.'},
      {h:'Titularité',p:'Suivez les obligations: image, calendrier, rapports annuels.'},
    ],
    cta_h:'Prêt à déposer votre candidature?',
    cta_p:'Accédez avec votre code ACES ou connectez-vous.',
    cta_b1:'Créer un compte', cta_b2:'Contacter ACES',
    footer_legal:'© 2026 ACES América. Tous droits réservés.',
    footer_privacy:'Confidentialité', footer_contact:'Contact',
    cookie_msg:'Cookies essentiels uniquement. Pas de suivi ni de données partagées.',
    cookie_accept:'Accepter', cookie_reject:'Essentiels', cookie_more:'En savoir plus',
  },
  de: {
    nav_roles:'Rollen', nav_proceso:'Prozess', nav_galardones:'Preise',
    nav_funciones:'Funktionen', nav_acceder:'Anmelden', nav_registro:'Registrieren',
    badge:'Offizielle ACES Europa & Amerika Plattform',
    hero_h1a:'Die digitale Verwaltung der',
    hero_h1b:'ACES Bewerbungen',
    hero_sub:'ACES Cities Network verwaltet den gesamten Lebenszyklus der ACES Sportpreisbewerbungen — vom Absichtsschreiben des Bürgermeisters bis zur Preisverleihung im Europäischen Parlament, vollständig digital.',
    hero_cta1:'Konto erstellen', hero_cta2:'Anmelden',
    ios_label:'Im', ios_store:'App Store',
    android_label:'Beta beitreten', android_store:'Android Beta',
    s1_num:'5.000+', s1_lbl:'Kommunen im ACES-Netzwerk',
    s2_num:'20+', s2_lbl:'offizielle Sportpreise',
    s3_num:'7', s3_lbl:'Sprachen',
    s4_num:'1999', s4_lbl:'ACES gegründet',
    roles_lbl:'Für wen', roles_h:'Drei Rollen, eine Plattform',
    roles_p:'Jeder Beteiligte hat eine eigene Oberfläche für seine Rolle im Bewerbungsprozess.',
    rm_tag:'MASTER · ADMIN', rm_h:'ACES-Verwaltung',
    rm_p:'Vollständige Kontrolle über alle Bewerbungen, Bewerter und den Vergabeprozess.',
    rm_f:['Globales Dashboard','Ausschüsse zuweisen','Endgültige Entscheidung','Gala & Titelträger','Zugangscodes'],
    re_tag:'BEWERTER', re_h:'Technische Bewerter',
    re_p:'Unabhängige Experten, die Bewerbungen nach offiziellen ACES-Kriterien bewerten.',
    re_f:['12-Abschnitte-Motor','Bis 100 Punkte','Interner Chat','Reiselogistik','Interessenkonflikt'],
    rc_tag:'STADT', rc_h:'Kandidatenstädte',
    rc_p:'Gemeinden, die eine ACES-Anerkennung anstreben.',
    rc_f:['Echtzeit-Status','Dokument-Portal','Zahlungen','Besuchslogistik','Chat mit ACES'],
    pipe_lbl:'Die Bewerbungsreise', pipe_h:'8 Phasen, vollständig verwaltet',
    pipe_p:'Absichtserklärung · Vorschriften · Gebühr · BID File · Besuch · Preisverleihung im Europäischen Parlament (Brüssel)',
    stages:['Beworben','Akzeptiert','Dokumentation','Besuch','Bewertung','Abstimmung','Entscheidung','Vergeben'],
    aw_lbl:'Preise', aw_h:'Alle offiziellen ACES-Sportpreise auf einer Plattform',
    aw_p:'Von der Weltsporthauptstadt bis zu Städten, Regionen, Inseln und Gemeinschaften in Europa, Amerika, Afrika, Asien und Ozeanien.',
    ft_lbl:'Funktionen', ft_h:'Alles für die Verwaltung einer ACES-Bewerbung',
    feats:[
      {h:'7 Sprachen',p:'Spanisch, Englisch, Französisch, Deutsch, Italienisch, Niederländisch, Portugiesisch.'},
      {h:'Rollenbasierte Sicherheit',p:'Städte sehen niemals Bewertungen. Bewerteridentitäten vertraulich.'},
      {h:'Offizieller Bewertungsmotor',p:'12 Abschnitte, bis zu 100 Punkte.'},
      {h:'Dual-Kanal-Chat',p:'Stadt-ACES und interner Ausschusskanal in Echtzeit.'},
      {h:'Reiselogistik',p:'Städte schlagen Flüge und Hotels vor. Bewerter bestätigen.'},
      {h:'iOS, Android & Web',p:'Native Apps und Web-Panel in Echtzeit synchronisiert.'},
      {h:'Dokumentenverwaltung',p:'BID-Dateien hochladen, prüfen und genehmigen.'},
      {h:'Titelträgerverfolgung',p:'Verpflichtungen verfolgen: Image, Sportkalender, Jahresberichte.'},
    ],
    cta_h:'Bereit für Ihre Kandidatur?',
    cta_p:'Zugang mit Ihrem ACES-Code oder Anmeldung als Mitglied.',
    cta_b1:'Konto erstellen', cta_b2:'ACES kontaktieren',
    footer_legal:'© 2026 ACES América. Alle Rechte vorbehalten.',
    footer_privacy:'Datenschutz', footer_contact:'Kontakt',
    cookie_msg:'Nur essentielle Cookies. Keine Tracking-Cookies oder Datenweitergabe.',
    cookie_accept:'Akzeptieren', cookie_reject:'Nur Essentielle', cookie_more:'Mehr Info',
  },
  it: {
    nav_roles:'Ruoli', nav_proceso:'Processo', nav_galardones:'Premi',
    nav_funciones:'Funzioni', nav_acceder:'Accedi', nav_registro:'Registrati',
    badge:'Piattaforma ufficiale ACES Europa & Americhe',
    hero_h1a:'La gestione digitale delle',
    hero_h1b:'candidature ACES',
    hero_sub:'ACES Cities Network gestisce l\'intero ciclo delle candidature ai premi sportivi ACES — dalla lettera di intenti del Sindaco alla cerimonia al Parlamento Europeo, completamente digitale.',
    hero_cta1:'Crea account', hero_cta2:'Accedi',
    ios_label:'Disponibile su', ios_store:'App Store',
    android_label:'Unisciti alla', android_store:'Beta Android',
    s1_num:'5.000+', s1_lbl:'municipalità nella rete ACES',
    s2_num:'20+', s2_lbl:'premi sportivi ufficiali',
    s3_num:'7', s3_lbl:'lingue',
    s4_num:'1999', s4_lbl:'fondazione ACES',
    roles_lbl:'Per chi', roles_h:'Tre ruoli, una piattaforma',
    roles_p:'Ogni parte ha un\'interfaccia dedicata adattata al suo ruolo nel processo.',
    rm_tag:'MASTER · ADMIN', rm_h:'Amministrazione ACES',
    rm_p:'Controllo totale su tutte le candidature, valutatori e il processo di aggiudicazione.',
    rm_f:['Dashboard globale','Commissioni di valutazione','Decisione finale','Gala e titolarità','Codici di accesso'],
    re_tag:'VALUTATORE', re_h:'Valutatori tecnici',
    re_p:'Esperti indipendenti che valutano le candidature secondo i criteri ufficiali ACES.',
    re_f:['Motore 12 sezioni','Fino a 100 punti','Chat interna','Logistica viaggio','Conflitto di interesse'],
    rc_tag:'CITTÀ', rc_h:'Città candidate',
    rc_p:'Comuni che aspirano al riconoscimento ACES. Segui la tua candidatura in tempo reale.',
    rc_f:['Stato in tempo reale','Portale documenti','Pagamenti','Logistica visita','Chat con ACES'],
    pipe_lbl:'Il percorso', pipe_h:'8 fasi, gestite digitalmente',
    pipe_p:'Lettera del Sindaco · Firma regolamento · Fee · BID File · Visita comitato · Cerimonia al Parlamento Europeo (Bruxelles)',
    stages:['Presentata','Accettata','Documentazione','Visita','Valutazione','Votazione','Decisione','Aggiudicata'],
    aw_lbl:'Premi', aw_h:'Tutti i riconoscimenti sportivi ufficiali ACES su un\'unica piattaforma',
    aw_p:'Dalla Capitale Mondiale dello Sport a Città, Regioni, Isole e Comunità in Europa, Americhe, Africa, Asia e Oceania.',
    ft_lbl:'Funzioni', ft_h:'Tutto per gestire una candidatura ACES',
    feats:[
      {h:'7 Lingue',p:'Spagnolo, inglese, francese, tedesco, italiano, olandese e portoghese.'},
      {h:'Sicurezza per ruoli',p:'Le città non vedono mai i punteggi. Identità dei valutatori riservata.'},
      {h:'Motore ufficiale',p:'12 sezioni, fino a 100 punti.'},
      {h:'Chat doppio canale',p:'Canale città-ACES e canale interno in tempo reale.'},
      {h:'Logistica viaggi',p:'Le città propongono voli e hotel. I valutatori confermano.'},
      {h:'iOS, Android e Web',p:'App native e pannello web sincronizzati in tempo reale.'},
      {h:'Gestione documentale',p:'Carica, rivedi e approva BID file.'},
      {h:'Titolarità',p:'Traccia obblighi: immagine, calendario sportivo, relazioni annuali.'},
    ],
    cta_h:'Pronto a presentare la tua candidatura?',
    cta_p:'Accedi con il tuo codice ACES o come membro esistente.',
    cta_b1:'Crea account', cta_b2:'Contatta ACES',
    footer_legal:'© 2026 ACES América. Tutti i diritti riservati.',
    footer_privacy:'Privacy', footer_contact:'Contatto',
    cookie_msg:'Solo cookie essenziali. Nessun cookie di tracciamento o condivisione dati.',
    cookie_accept:'Accetta', cookie_reject:'Solo essenziali', cookie_more:'Più info',
  },
  nl: {
    nav_roles:'Rollen', nav_proceso:'Proces', nav_galardones:'Prijzen',
    nav_funciones:'Functies', nav_acceder:'Aanmelden', nav_registro:'Registreren',
    badge:'Officieel ACES Europa & Amerika Platform',
    hero_h1a:'Het digitale beheer van',
    hero_h1b:'ACES kandidaturen',
    hero_sub:'ACES Cities Network beheert de volledige levenscyclus van ACES sportprijskandidaturen — van de intentieverklaring van de burgemeester tot de uitreiking in het Europees Parlement, volledig digitaal.',
    hero_cta1:'Account aanmaken', hero_cta2:'Aanmelden',
    ios_label:'Beschikbaar in', ios_store:'App Store',
    android_label:'Lid worden van', android_store:'Android Beta',
    s1_num:'5.000+', s1_lbl:'gemeenten in het ACES-netwerk',
    s2_num:'20+', s2_lbl:'officiële sportprijzen',
    s3_num:'7', s3_lbl:'talen',
    s4_num:'1999', s4_lbl:'ACES opgericht',
    roles_lbl:'Voor wie', roles_h:'Drie rollen, één platform',
    roles_p:'Elke partij heeft een eigen interface aangepast aan haar rol in het proces.',
    rm_tag:'MASTER · ADMIN', rm_h:'ACES Administratie',
    rm_p:'Volledige controle over alle kandidaturen, evaluatoren en het toewijzingsproces.',
    rm_f:['Globaal dashboard','Evaluatiecommissies','Definitieve beslissing','Gala & titelhouders','Toegangscodes'],
    re_tag:'EVALUATOR', re_h:'Technische Evaluatoren',
    re_p:'Onafhankelijke experts die kandidaturen beoordelen volgens officiële ACES-criteria.',
    re_f:['12-secties motor','Tot 100 punten','Interne chat','Reislogistiek','Belangenconflict'],
    rc_tag:'STAD', rc_h:'Kandidaatsteden',
    rc_p:'Gemeenten die streven naar ACES-erkenning. Volg uw kandidatuur in realtime.',
    rc_f:['Realtime status','Documentportaal','Betalingen','Bezoeklogistiek','Chat met ACES'],
    pipe_lbl:'De kandidatuurreis', pipe_h:'8 fasen, volledig beheerd',
    pipe_p:'Intentieverklaring · Reglement · Bijdrage · BID File · Bezoek comité · Uitreiking Europees Parlement (Brussel)',
    stages:['Ingediend','Geaccepteerd','Documentatie','Bezoek','Evaluatie','Stemming','Beslissing','Toegewezen'],
    aw_lbl:'Prijzen', aw_h:'Alle officiële ACES-sportprijzen op één platform',
    aw_p:'Van de Wereld Sporthoofstad tot Steden, Regio\'s, Eilanden en Gemeenschappen in Europa, Amerika, Afrika, Azië en Oceanië.',
    ft_lbl:'Functies', ft_h:'Alles voor het beheren van een ACES-kandidatuur',
    feats:[
      {h:'7 Talen',p:'Spaans, Engels, Frans, Duits, Italiaans, Nederlands en Portugees.'},
      {h:'Rolgebaseerde beveiliging',p:'Steden zien nooit scores. Evaluatoridentiteiten vertrouwelijk.'},
      {h:'Officiële evaluatiemotor',p:'12 secties, tot 100 punten.'},
      {h:'Dual-kanaalchat',p:'Stad-ACES en intern commissiekanaal in realtime.'},
      {h:'Reislogistiek',p:'Steden stellen vluchten en hotels voor. Evaluatoren bevestigen.'},
      {h:'iOS, Android & Web',p:'Native apps en webpaneel gesynchroniseerd in realtime.'},
      {h:'Documentbeheer',p:'BID-bestanden uploaden, beoordelen en goedkeuren.'},
      {h:'Titelhoudersbeheer',p:'Verplichtingen: imago, sportkalender, jaarverslagen.'},
    ],
    cta_h:'Klaar om uw kandidatuur in te dienen?',
    cta_p:'Toegang met uw ACES-code of aanmelden als lid.',
    cta_b1:'Account aanmaken', cta_b2:'Contact ACES',
    footer_legal:'© 2026 ACES América. Alle rechten voorbehouden.',
    footer_privacy:'Privacybeleid', footer_contact:'Contact',
    cookie_msg:'Alleen essentiële cookies. Geen tracking of datadeling.',
    cookie_accept:'Accepteren', cookie_reject:'Alleen essentiële', cookie_more:'Meer info',
  },
  pt: {
    nav_roles:'Papéis', nav_proceso:'Processo', nav_galardones:'Prémios',
    nav_funciones:'Funções', nav_acceder:'Entrar', nav_registro:'Registar',
    badge:'Plataforma oficial ACES Europa & Américas',
    hero_h1a:'A gestão digital das',
    hero_h1b:'candidaturas ACES',
    hero_sub:'ACES Cities Network gere o ciclo completo das candidaturas aos prémios desportivos ACES — da carta de intenção do Presidente à cerimónia no Parlamento Europeu, totalmente digital.',
    hero_cta1:'Criar conta', hero_cta2:'Entrar',
    ios_label:'Disponível na', ios_store:'App Store',
    android_label:'Aderir à', android_store:'Beta Android',
    s1_num:'5.000+', s1_lbl:'municípios na rede ACES',
    s2_num:'20+', s2_lbl:'prémios desportivos oficiais',
    s3_num:'7', s3_lbl:'idiomas',
    s4_num:'1999', s4_lbl:'fundação ACES',
    roles_lbl:'Para quem', roles_h:'Três papéis, uma plataforma',
    roles_p:'Cada parte tem uma interface dedicada adaptada ao seu papel no processo.',
    rm_tag:'MASTER · ADMIN', rm_h:'Administração ACES',
    rm_p:'Controlo total sobre todas as candidaturas, avaliadores e o processo de adjudicação.',
    rm_f:['Painel global','Comissões de avaliação','Decisão final','Gala e titularidade','Códigos de acesso'],
    re_tag:'AVALIADOR', re_h:'Avaliadores técnicos',
    re_p:'Peritos independentes que avaliam candidaturas segundo os critérios oficiais ACES.',
    re_f:['Motor 12 seções','Até 100 pontos','Chat interno','Logística viagem','Conflito de interesses'],
    rc_tag:'CIDADE', rc_h:'Cidades candidatas',
    rc_p:'Municípios que aspiram ao reconhecimento ACES. Acompanhe a sua candidatura em tempo real.',
    rc_f:['Estado em tempo real','Portal documentos','Pagamentos','Logística visita','Chat com ACES'],
    pipe_lbl:'O percurso', pipe_h:'8 fases, geridas digitalmente',
    pipe_p:'Carta do Presidente · Regulamento · Taxa · BID File · Visita do comité · Cerimónia no Parlamento Europeu (Bruxelas)',
    stages:['Submetida','Aceite','Documentação','Visita','Avaliação','Votação','Decisão','Adjudicada'],
    aw_lbl:'Prémios', aw_h:'Todos os galardões desportivos oficiais ACES numa só plataforma',
    aw_p:'Desde a Capital Mundial do Desporto até Cidades, Regiões, Ilhas e Comunidades na Europa, Américas, África, Ásia e Oceânia.',
    ft_lbl:'Funcionalidades', ft_h:'Tudo para gerir uma candidatura ACES',
    feats:[
      {h:'7 Idiomas',p:'Espanhol, inglês, francês, alemão, italiano, neerlandês e português.'},
      {h:'Segurança por papéis',p:'As cidades nunca veem pontuações. Identidade dos avaliadores confidencial.'},
      {h:'Motor oficial',p:'12 seções, até 100 pontos.'},
      {h:'Chat canal duplo',p:'Canal cidade-ACES e canal interno em tempo real.'},
      {h:'Logística de viagens',p:'As cidades propõem voos e hotéis. Os avaliadores confirmam.'},
      {h:'iOS, Android e Web',p:'Apps nativas e painel web sincronizados em tempo real.'},
      {h:'Gestão documental',p:'Carregue, reveja e aprove BID files.'},
      {h:'Titularidade',p:'Controle obrigações: imagem, calendário desportivo, relatórios anuais.'},
    ],
    cta_h:'Pronto para apresentar a sua candidatura?',
    cta_p:'Aceda com o seu código ACES ou entre como membro existente.',
    cta_b1:'Criar conta', cta_b2:'Contactar ACES',
    footer_legal:'© 2026 ACES América. Todos os direitos reservados.',
    footer_privacy:'Privacidade', footer_contact:'Contacto',
    cookie_msg:'Apenas cookies essenciais. Sem rastreamento ou partilha de dados.',
    cookie_accept:'Aceitar', cookie_reject:'Só essenciais', cookie_more:'Mais informação',
  },
};

const LANGS = [
  {code:'es',label:'ES'},{code:'en',label:'EN'},{code:'fr',label:'FR'},
  {code:'de',label:'DE'},{code:'it',label:'IT'},{code:'nl',label:'NL'},{code:'pt',label:'PT'},
];

const AWARDS = [
  'World Capital of Sport','European Capital of Sport','European Region of Sport',
  'European City of Sport','European Island of Sport','European Community of Sport',
  'European Town of Sport','American Capital of Sport','American City of Sport',
  'American Town of Sport','American Community of Sport','American Island of Sport',
  'American Region of Sport','African Capital of Sport','Asian Capital of Sport',
  'Oceanian Capital of Sport','Mediterranean Capital of Sport',
  'Euro-Atlantic Capital of Sport','Capital of Sport for Integration & Volunteering',
  'Capital of Cycling','Capital of Winter Sports',
  'European & Worldwide Sport and Healthy Company',
];

// SVG inline icons — sin emojis
const Ico = {
  globe:     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  lock:      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  chart:     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  chat:      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  plane:     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
  mobile:    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>,
  folder:    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
  medal:     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="15" r="5"/><path d="M8.56 2.9 7 7l5 2 5-2-1.56-4.1a1 1 0 0 0-.94-.65H9.5a1 1 0 0 0-.94.65z"/></svg>,
  star:      <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFB300"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  apple:     <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>,
  android:   <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24C14.93 8.28 13.5 7.88 12 7.88c-1.5 0-2.93.4-4.47 1.03L5.65 5.67c-.18-.28-.54-.37-.83-.22-.3.16-.42.54-.26.85L6.4 9.48C3.94 11.07 2.26 13.6 2 16.5h20c-.26-2.9-1.94-5.43-4.4-7.02zM7 15.25c-.69 0-1.25-.56-1.25-1.25S6.31 12.75 7 12.75s1.25.56 1.25 1.25S7.69 15.25 7 15.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/></svg>,
  shield:    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  clipboard: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>,
  building:  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
};

const FEAT_ICONS = [Ico.globe, Ico.lock, Ico.chart, Ico.chat, Ico.plane, Ico.mobile, Ico.folder, Ico.medal];
const ROLE_ICONS = [Ico.shield, Ico.clipboard, Ico.building];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@800;900&display=swap');

:root{--navy:#050e1a;--accent:#00CFC8;--amber:#FFB300;--text:#f0f6ff;--text2:#7a9fc0;--border:rgba(255,255,255,.08);--card:rgba(255,255,255,.04);--r:16px;}
.ld *{box-sizing:border-box;margin:0;padding:0;}
.ld{font-family:'Roboto',sans-serif;background:var(--navy);color:var(--text);overflow-x:hidden;scroll-behavior:smooth;}
.ld a{text-decoration:none;color:inherit;}
.t{font-family:'Nunito','Roboto',sans-serif;font-weight:800;letter-spacing:-.02em;}

.nav{position:fixed;top:0;left:0;right:0;z-index:200;height:64px;padding:0 48px;
  display:flex;align-items:center;justify-content:space-between;
  background:rgba(5,14,26,.95);backdrop-filter:blur(20px);
  border-bottom:1px solid var(--border);transition:box-shadow .3s;}
.nav.sc{box-shadow:0 4px 32px rgba(0,0,0,.5);}
.nav-logo{display:flex;align-items:center;gap:11px;cursor:pointer;}
.nav-sep{width:1px;height:26px;background:rgba(255,255,255,.18);}
.nav-name{font-size:14px;font-weight:600;color:rgba(255,255,255,.82);}
.nav-links{display:flex;gap:28px;}
.nav-links a{font-size:13px;color:var(--text2);cursor:pointer;transition:color .15s;font-weight:500;}
.nav-links a:hover{color:var(--accent);}
.nav-cta{display:flex;gap:8px;}
.btn-g{padding:8px 18px;border-radius:8px;border:1px solid rgba(255,255,255,.15);font-size:13px;font-weight:600;cursor:pointer;background:transparent;color:var(--text);font-family:'Roboto',sans-serif;transition:all .2s;}
.btn-g:hover{background:rgba(255,255,255,.08);}
.btn-a{padding:8px 20px;border-radius:8px;background:var(--accent);color:#050e1a;font-size:13px;font-weight:700;cursor:pointer;border:none;font-family:'Roboto',sans-serif;transition:all .2s;}
.btn-a:hover{background:#00e0d8;transform:translateY(-1px);}

.langbar{position:fixed;top:64px;left:0;right:0;z-index:199;height:36px;
  background:rgba(5,14,26,.9);border-bottom:1px solid var(--border);
  padding:0 48px;display:flex;align-items:center;gap:4px;}
.lb{padding:3px 11px;border-radius:20px;font-size:11px;font-weight:700;cursor:pointer;
  border:1px solid transparent;background:transparent;color:rgba(255,255,255,.35);
  transition:all .15s;font-family:'Roboto',sans-serif;}
.lb.on,.lb:hover{background:rgba(0,207,200,.1);color:var(--accent);border-color:rgba(0,207,200,.25);}

.hero{min-height:100vh;display:flex;align-items:center;justify-content:center;
  text-align:center;padding:160px 48px 100px;position:relative;overflow:hidden;}
.hero::before{content:'';position:absolute;inset:0;
  background:radial-gradient(ellipse 80% 55% at 50% 30%,rgba(27,75,138,.5) 0%,transparent 70%);}
.hero-in{position:relative;z-index:1;max-width:900px;margin:0 auto;}
.hero-logos{display:flex;align-items:center;justify-content:center;gap:20px;margin-bottom:36px;}
.logo-aces{height:36px;width:auto;object-fit:contain;opacity:.9;}
.logo-icon{height:52px;width:52px;border-radius:12px;object-fit:cover;box-shadow:0 4px 20px rgba(0,0,0,.4);}
.logo-vsep{width:1px;height:34px;background:rgba(255,255,255,.2);}
.badge{display:inline-flex;align-items:center;gap:7px;padding:5px 16px;border-radius:100px;
  background:rgba(255,179,0,.1);border:1px solid rgba(255,179,0,.3);color:var(--amber);
  font-size:11px;font-weight:700;letter-spacing:.07em;margin-bottom:24px;font-family:'Roboto',sans-serif;}
.h1{font-size:clamp(36px,5.5vw,70px);line-height:1.05;margin-bottom:22px;}
.h1 span{color:var(--accent);}
.hero-sub{font-size:clamp(15px,1.8vw,18px);color:var(--text2);max-width:620px;
  margin:0 auto 36px;line-height:1.7;font-weight:400;}
.btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-bottom:20px;}
.btn-p{background:var(--accent);color:#050e1a;padding:14px 32px;border-radius:10px;
  font-weight:700;font-size:15px;cursor:pointer;border:none;
  font-family:'Roboto',sans-serif;transition:all .2s;}
.btn-p:hover{background:#00e0d8;transform:translateY(-2px);box-shadow:0 12px 40px rgba(0,207,200,.28);}
.btn-s{background:rgba(255,255,255,.07);color:var(--text);padding:14px 32px;border-radius:10px;
  font-weight:600;font-size:15px;border:1px solid rgba(255,255,255,.15);cursor:pointer;
  font-family:'Roboto',sans-serif;transition:all .2s;}
.btn-s:hover{background:rgba(255,255,255,.13);}

.stores{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-bottom:64px;}
.store-btn{display:flex;align-items:center;gap:10px;padding:11px 22px;
  border-radius:10px;transition:all .2s;cursor:pointer;}
.store-ios{background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);color:var(--text);}
.store-ios:hover{background:rgba(255,255,255,.13);}
.store-android{background:rgba(0,207,200,.07);border:1px solid rgba(0,207,200,.25);color:var(--accent);}
.store-android:hover{background:rgba(0,207,200,.15);}
.store-label{font-size:10px;opacity:.6;line-height:1.2;display:block;}
.store-name{font-size:14px;font-weight:700;display:block;line-height:1.3;}

.stats{display:flex;gap:48px;justify-content:center;flex-wrap:wrap;}
.stat-num{font-size:38px;font-weight:800;color:var(--accent);display:block;font-family:'Nunito',sans-serif;}
.stat-lbl{font-size:12px;color:var(--text2);display:block;margin-top:4px;}

.wrap{max-width:1160px;margin:0 auto;padding:0 48px;}
.sec{padding:96px 0;}
.sec-lbl{font-size:11px;font-weight:700;letter-spacing:.12em;color:var(--accent);
  text-transform:uppercase;margin-bottom:12px;font-family:'Roboto',sans-serif;}
.sec-h{font-size:clamp(26px,3.5vw,44px);margin-bottom:12px;}
.sec-p{font-size:16px;color:var(--text2);line-height:1.7;max-width:560px;font-weight:400;}
.div{height:1px;background:linear-gradient(90deg,transparent,rgba(0,207,200,.25),transparent);margin:0 48px;}

.roles{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:20px;margin-top:52px;}
.role{background:var(--card);border:1px solid var(--border);border-radius:var(--r);
  padding:28px;transition:all .3s;}
.role:hover{transform:translateY(-4px);border-color:rgba(255,255,255,.14);background:rgba(255,255,255,.06);}
.role-top{display:flex;align-items:center;gap:12px;margin-bottom:16px;}
.role-icon{width:44px;height:44px;border-radius:11px;display:flex;align-items:center;justify-content:center;}
.role-tag{display:inline-block;padding:2px 10px;border-radius:20px;
  font-size:9px;font-weight:800;letter-spacing:.1em;font-family:'Roboto',sans-serif;}
.role h3{font-size:18px;margin-bottom:8px;}
.role p{font-size:13px;color:var(--text2);line-height:1.65;margin-bottom:16px;font-weight:400;}
.role-feats{list-style:none;display:flex;flex-direction:column;gap:7px;}
.role-feats li{display:flex;align-items:flex-start;gap:8px;font-size:13px;color:rgba(255,255,255,.5);}
.rdot{width:5px;height:5px;border-radius:50%;flex-shrink:0;margin-top:5px;}

.pipe-wrap{margin-top:48px;background:rgba(255,255,255,.02);border:1px solid var(--border);
  border-radius:20px;padding:44px 36px;}
.pipe{display:flex;overflow-x:auto;padding-bottom:4px;}
.pipe-step{flex:1;min-width:90px;display:flex;flex-direction:column;align-items:center;gap:10px;position:relative;}
.pipe-step::after{content:'';position:absolute;top:22px;left:50%;width:100%;height:2px;
  background:rgba(255,255,255,.07);z-index:0;}
.pipe-step:last-child::after{display:none;}
.pipe-num{width:44px;height:44px;border-radius:50%;background:rgba(10,34,64,.8);
  border:1.5px solid rgba(255,255,255,.1);display:flex;align-items:center;justify-content:center;
  font-size:15px;font-weight:700;color:var(--text2);position:relative;z-index:1;
  transition:all .3s;font-family:'Nunito',sans-serif;}
.pipe-step:hover .pipe-num{border-color:var(--accent);color:var(--accent);background:rgba(0,207,200,.08);}
.pipe-lbl{font-size:11px;color:var(--text2);text-align:center;font-weight:500;line-height:1.4;}
.pipe-desc{font-size:12px;color:var(--text2);line-height:1.7;margin-top:24px;
  text-align:center;font-style:italic;border-top:1px solid var(--border);padding-top:20px;}

.awards{display:flex;flex-wrap:wrap;gap:10px;margin-top:40px;}
.award{padding:8px 18px;border-radius:100px;background:rgba(255,255,255,.04);
  border:1px solid rgba(255,255,255,.09);font-size:12px;font-weight:500;
  color:rgba(255,255,255,.65);transition:all .2s;cursor:default;font-family:'Roboto',sans-serif;}
.award:hover{background:rgba(0,207,200,.08);border-color:rgba(0,207,200,.3);color:var(--accent);}

.feats{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:16px;margin-top:52px;}
.feat{padding:24px;border-radius:14px;background:var(--card);border:1px solid var(--border);transition:all .3s;}
.feat:hover{transform:translateY(-3px);border-color:rgba(255,255,255,.14);}
.feat-ico{margin-bottom:14px;}
.feat h4{font-size:15px;margin-bottom:6px;}
.feat p{font-size:13px;color:var(--text2);line-height:1.65;font-weight:400;}

.cta-box{background:linear-gradient(135deg,rgba(27,75,138,.45),rgba(10,110,250,.2));
  border:1px solid rgba(27,75,138,.4);border-radius:24px;
  padding:72px 48px;text-align:center;margin:96px 48px;}
.cta-box h2{font-size:clamp(28px,4vw,48px);margin-bottom:14px;}
.cta-box p{color:var(--text2);font-size:17px;margin-bottom:36px;line-height:1.65;font-weight:400;}
.cta-btns{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}

.footer{border-top:1px solid var(--border);padding:36px 48px;
  display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:16px;}
.footer-left{display:flex;align-items:center;gap:14px;}
.footer-legal{font-size:12px;color:rgba(255,255,255,.3);}
.footer-links{display:flex;gap:20px;}
.footer-links a{font-size:12px;color:rgba(255,255,255,.4);transition:color .15s;}
.footer-links a:hover{color:var(--accent);}

.cookie{position:fixed;bottom:24px;left:24px;right:24px;z-index:9999;
  background:rgba(8,22,40,.97);border:1px solid rgba(0,207,200,.22);
  border-radius:14px;padding:18px 24px;display:flex;align-items:center;
  gap:16px;flex-wrap:wrap;backdrop-filter:blur(16px);
  box-shadow:0 8px 40px rgba(0,0,0,.6);max-width:960px;
  margin-left:auto;margin-right:auto;animation:sU .4s ease;}
@keyframes sU{from{transform:translateY(80px);opacity:0}to{transform:translateY(0);opacity:1}}
.cookie p{font-size:13px;color:rgba(255,255,255,.7);line-height:1.5;flex:1;font-weight:400;}
.ck-btns{display:flex;gap:8px;flex-shrink:0;}
.ck-a{background:var(--accent);color:#050e1a;padding:8px 18px;border-radius:8px;
  font-weight:700;font-size:12px;cursor:pointer;border:none;font-family:'Roboto',sans-serif;}
.ck-r{background:transparent;color:rgba(255,255,255,.55);padding:8px 18px;border-radius:8px;
  font-weight:500;font-size:12px;cursor:pointer;border:1px solid rgba(255,255,255,.18);
  font-family:'Roboto',sans-serif;}
.ck-m{background:transparent;color:var(--accent);padding:8px 12px;border-radius:8px;
  font-size:12px;cursor:pointer;border:none;text-decoration:underline;font-family:'Roboto',sans-serif;}

@media(max-width:768px){
  .nav{padding:0 20px;} .nav-links{display:none;}
  .hero{padding:140px 24px 80px;} .wrap{padding:0 24px;}
  .div{margin:0 24px;} .stats{gap:28px;} .langbar{padding:0 20px;}
  .footer{padding:28px 24px;flex-direction:column;align-items:flex-start;}
  .pipe-wrap{padding:28px 16px;} .cta-box{padding:48px 24px;margin:48px 24px;}
  .cookie{bottom:12px;left:12px;right:12px;}
}
`;

export default function LandingView() {
  const navigate = useNavigate();
  const saved = localStorage.getItem('acescn_lang');
  const browser = (navigator.language || 'en').split('-')[0];
  const init = T[saved] ? saved : T[browser] ? browser : 'en';
  const [lang, setLang] = useState(init);
  const [scrolled, setScrolled] = useState(false);
  const [cookieDone, setCookieDone] = useState(() => localStorage.getItem('acescn_cookies') !== null);
  const t = k => T[lang]?.[k] ?? T.en?.[k] ?? k;
  const changeLang = c => { setLang(c); localStorage.setItem('acescn_lang', c); };

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn, { passive:true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = id => document.getElementById(id)?.scrollIntoView({ behavior:'smooth' });

  const roleColors = [
    { tag:'rgba(255,179,0,.12)', tagText:'#FFB300', dot:'#FFB300', icon:'rgba(255,179,0,.12)', iconBorder:'rgba(255,179,0,.3)', iconColor:'#FFB300' },
    { tag:'rgba(0,207,200,.1)', tagText:'#00CFC8', dot:'#00CFC8', icon:'rgba(0,207,200,.1)', iconBorder:'rgba(0,207,200,.25)', iconColor:'#00CFC8' },
    { tag:'rgba(10,110,250,.12)', tagText:'#7eb3ff', dot:'#7eb3ff', icon:'rgba(10,110,250,.12)', iconBorder:'rgba(10,110,250,.3)', iconColor:'#7eb3ff' },
  ];
  const rks = ['rm','re','rc'];

  return (
    <>
      <style>{CSS}</style>
      <div className="ld">

        {/* NAV */}
        <nav className={`nav${scrolled?' sc':''}`}>
          <button type="button" className="nav-logo" aria-label="Volver arriba" onClick={() => window.scrollTo({top:0,behavior:'smooth'})} style={{background:'none',border:'none',cursor:'pointer',padding:0}}>
            <img src="/logo_aces_white.png" alt="ACES" style={{height:28,width:'auto',objectFit:'contain'}}/>
            <div className="nav-sep"/>
            <img src="/app_icon.jpg" alt="ACES Cities" style={{height:30,width:30,borderRadius:7,objectFit:'cover'}}/>
            <span className="nav-name">ACES Cities Network</span>
          </button>
          <div className="nav-links">
            <button onClick={() => go('roles')} style={{background:'none',border:'none',cursor:'pointer',color:'inherit',font:'inherit'}}>{t('nav_roles')}</button>
            <button onClick={() => go('pipeline')} style={{background:'none',border:'none',cursor:'pointer',color:'inherit',font:'inherit'}}>{t('nav_proceso')}</button>
            <button onClick={() => go('awards')} style={{background:'none',border:'none',cursor:'pointer',color:'inherit',font:'inherit'}}>{t('nav_galardones')}</button>
            <button onClick={() => go('features')} style={{background:'none',border:'none',cursor:'pointer',color:'inherit',font:'inherit'}}>{t('nav_funciones')}</button>
          </div>
          <div className="nav-cta">
            <button className="btn-g" onClick={() => navigate('/login')}>{t('nav_acceder')}</button>
            <button className="btn-a" onClick={() => navigate('/registro')}>{t('nav_registro')}</button>
          </div>
        </nav>

        {/* LANG */}
        <div className="langbar">
          {LANGS.map(l => (
            <button key={l.code} className={`lb${lang===l.code?' on':''}`}
              onClick={() => changeLang(l.code)}>{l.label}</button>
          ))}
        </div>

        {/* HERO */}
        <section className="hero">
          <div className="hero-in">
            <div className="hero-logos">
              <img src="/logo_aces_white.png" alt="ACES" className="logo-aces"/>
              <div className="logo-vsep"/>
              <img src="/app_icon.jpg" alt="ACES Cities Network" className="logo-icon"/>
            </div>
            <div className="badge">{Ico.star} {t('badge')}</div>
            <h1 className="h1 t">{t('hero_h1a')}<br/><span>{t('hero_h1b')}</span></h1>
            <p className="hero-sub">{t('hero_sub')}</p>
            <div className="btns">
              <button className="btn-p" onClick={() => navigate('/registro')}>{t('hero_cta1')}</button>
              <button className="btn-s" onClick={() => navigate('/login')}>{t('hero_cta2')}</button>
            </div>
            <div className="stores">
              <a href="https://apps.apple.com/us/app/aces-cities/id6760301741"
                 target="_blank" rel="noreferrer" className="store-btn store-ios">
                {Ico.apple}
                <span>
                  <span className="store-label">{t('ios_label')}</span>
                  <span className="store-name">{t('ios_store')}</span>
                </span>
              </a>
              <a href="mailto:redes@acesamerica.org?subject=Beta Android ACES Cities Network&body=Me interesa participar en la beta de Android de ACES Cities Network. Nombre: | Ciudad: "
                 className="store-btn store-android">
                {Ico.android}
                <span>
                  <span className="store-label" style={{color:'rgba(0,207,200,.7)'}}>{t('android_label')}</span>
                  <span className="store-name">{t('android_store')}</span>
                </span>
              </a>
            </div>
            <div className="stats">
              {[['s1_num','s1_lbl'],['s2_num','s2_lbl'],['s3_num','s3_lbl'],['s4_num','s4_lbl']].map(([n,l]) => (
                <div key={n}><span className="stat-num">{t(n)}</span><span className="stat-lbl">{t(l)}</span></div>
              ))}
            </div>
          </div>
        </section>

        <div className="div"/>

        {/* ROLES */}
        <div className="wrap">
          <section className="sec" id="roles">
            <div className="sec-lbl">{t('roles_lbl')}</div>
            <h2 className="sec-h t">{t('roles_h')}</h2>
            <p className="sec-p">{t('roles_p')}</p>
            <div className="roles">
              {rks.map((rk, i) => {
                const c = roleColors[i];
                const feats = t(`${rk}_f`);
                return (
                  <div className="role" key={rk}>
                    <div className="role-top">
                      <div className="role-icon" style={{background:c.icon,border:`1px solid ${c.iconBorder}`,color:c.iconColor}}>
                        {ROLE_ICONS[i]}
                      </div>
                      <div className="role-tag" style={{background:c.tag,color:c.tagText}}>{t(`${rk}_tag`)}</div>
                    </div>
                    <h3 className="t">{t(`${rk}_h`)}</h3>
                    <p>{t(`${rk}_p`)}</p>
                    <ul className="role-feats">
                      {Array.isArray(feats) && feats.map((f, j) => (
                        <li key={j}><div className="rdot" style={{background:c.dot}}/>{f}</li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </section>
        </div>

        <div className="div"/>

        {/* PIPELINE */}
        <div className="wrap">
          <section className="sec" id="pipeline">
            <div className="sec-lbl">{t('pipe_lbl')}</div>
            <h2 className="sec-h t">{t('pipe_h')}</h2>
            <div className="pipe-wrap">
              <div className="pipe">
                {(t('stages')||[]).map((s, i) => (
                  <div className="pipe-step" key={i}>
                    <div className="pipe-num">{i+1}</div>
                    <div className="pipe-lbl">{s}</div>
                  </div>
                ))}
              </div>
              <p className="pipe-desc">{t('pipe_p')}</p>
            </div>
          </section>
        </div>

        <div className="div"/>

        {/* AWARDS */}
        <div className="wrap">
          <section className="sec" id="awards">
            <div className="sec-lbl">{t('aw_lbl')}</div>
            <h2 className="sec-h t">{t('aw_h')}</h2>
            <p className="sec-p">{t('aw_p')}</p>
            <div className="awards">
              {AWARDS.map(a => <div className="award" key={a}>{a}</div>)}
            </div>
          </section>
        </div>

        <div className="div"/>

        {/* FEATURES */}
        <div className="wrap">
          <section className="sec" id="features">
            <div className="sec-lbl">{t('ft_lbl')}</div>
            <h2 className="sec-h t">{t('ft_h')}</h2>
            <div className="feats">
              {(t('feats')||[]).map((f, i) => (
                <div className="feat" key={i}>
                  <div className="feat-ico" style={{color:'#00CFC8'}}>{FEAT_ICONS[i]}</div>
                  <h4 className="t">{f.h}</h4>
                  <p>{f.p}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* CTA */}
        <div className="cta-box">
          <h2 className="t">{t('cta_h')}</h2>
          <p>{t('cta_p')}</p>
          <div className="cta-btns">
            <button className="btn-p" onClick={() => navigate('/registro')}>{t('cta_b1')}</button>
            <a href="mailto:redes@acesamerica.org">
              <button className="btn-s">{t('cta_b2')}</button>
            </a>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="footer">
          <div className="footer-left">
            <img src="/logo_aces_white.png" alt="ACES" style={{height:22,opacity:.45}}/>
            <span className="footer-legal">{t('footer_legal')}</span>
          </div>
          <div className="footer-links">
            <a href="/privacidad.html" target="_blank">{t('footer_privacy')}</a>
            <a href="mailto:redes@acesamerica.org">{t('footer_contact')}</a>
            <a href="https://aceseurope.eu" target="_blank" rel="noreferrer">aceseurope.eu</a>
          </div>
        </footer>

        {/* COOKIE GDPR */}
        {!cookieDone && (
          <div className="cookie">
            <p>{t('cookie_msg')}{' '}
              <a href="/privacidad.html" target="_blank" style={{color:'var(--accent)'}}>{t('cookie_more')}</a>
            </p>
            <div className="ck-btns">
              <button className="ck-a" onClick={() => { localStorage.setItem('acescn_cookies','accepted'); setCookieDone(true); }}>{t('cookie_accept')}</button>
              <button className="ck-r" onClick={() => { localStorage.setItem('acescn_cookies','essential'); setCookieDone(true); }}>{t('cookie_reject')}</button>
            </div>
          </div>
        )}

      </div>
    </>
  );
}
